import React from 'react';
import type { Nullable } from 'corgi-types';

import type { RenderingType } from '../../../product-mvc-buttons/components/enums';
import type { Group, GroupValueArticle } from '../../../product-mvc-buttons/components/types';
import { Flex } from '../Flex';
import Groups from './Groups';
import ImageGallery from './ImageGallery';
import type { ChangeHandler, SelectedValue } from './types';

interface DrawerContentProps {
  sku: string;
  url: string;
  title: Nullable<string>;
  variationKey: Nullable<string>;
  items: Group[];
  count: number;
  renderingType: RenderingType;
  selectedValue: SelectedValue;
  images: GroupValueArticle['images'];
  fabricSample: string;
  onChange: ChangeHandler;
  isVariationDrawer?: boolean;
}

const DrawerContent = ({
  sku,
  url,
  title,
  variationKey,
  items,
  count,
  renderingType,
  onChange,
  selectedValue,
  images,
  fabricSample,
  isVariationDrawer,
}: DrawerContentProps) => (
  <Flex flexDirection="column">
    <ImageGallery images={images} fabricSample={fabricSample} name={title ?? ''} />
    <Groups
      sku={sku}
      url={url}
      isVariationDrawer={isVariationDrawer}
      variationKey={variationKey}
      items={items}
      listLength={count}
      renderingType={renderingType}
      onChange={onChange}
      selectedValue={selectedValue}
    />
  </Flex>
);

export default DrawerContent;
